import {AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {AccountCreationService} from '../../../services/account-creation.service';

@Component({
    selector: 'app-aof-modal',
    templateUrl: './aof-modal.component.html',
    styleUrls: ['../creation-modal.component.less'],
    standalone: false
})
export class AoFModalComponent implements OnInit, AfterViewInit {
  @ViewChild('aofSelectionList', { static: true }) list: ElementRef;
  @ViewChildren('aofCheckbox') aofCheckbox: QueryList<ElementRef>;
  fixedAreasOfFocus = [];
  selectedAreasOfFocus = [];
  allChecked = false;
  selectedFocus = true;


  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode === 9 && this.selectedFocus) {
      (this.list.nativeElement.firstElementChild as HTMLElement).focus();
      this.selectedFocus = false;
    }
    if (event.keyCode === 27) {
      this.cancelModal();
    }
  }

  constructor(private modalRef: BsModalRef,
              private accountCreationService: AccountCreationService) {
  }

  ngOnInit() {
    this.selectedAreasOfFocus = this.accountCreationService.getChosenAreaOfFocus();
    this.fixedAreasOfFocus = this.accountCreationService.getCombinedAof();
    this.allChecked = this.checkIfAllSelected();
    this.checkSelectedAof();
  }

  ngAfterViewInit() {
    this.list.nativeElement.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  private onKeyDown(evt) {
    let currentActive = document.activeElement;
    // tslint:disable-next-line:typeof-compare
    if (currentActive.nodeName === 'INPUT') {
      currentActive = currentActive.parentElement;
    }
    switch (evt.keyCode) {
      case 38: // up
        (currentActive.previousElementSibling as HTMLElement).focus();
        evt.preventDefault();
        break;
      case 40: // down
        (currentActive.nextElementSibling as HTMLElement).focus();
        evt.preventDefault();
        break;
      case 32: // space
        const checkbox = (currentActive.firstElementChild as HTMLInputElement);
        if (checkbox.id === 'aof-select-all') {
          this.toggleSelectAllAoFOnPage();
        } else {
          const rolesIndex = +checkbox.id.replace('area', '');
          this.checkItem(this.fixedAreasOfFocus[rolesIndex], !checkbox.checked);
        }
        evt.preventDefault();
        break;
    }
  }

  private checkSelectedAof() {
    this.fixedAreasOfFocus = this.fixedAreasOfFocus.map((aof) => {
      let roleItem: any = {};
      roleItem.aof = aof;
      roleItem.checked = this.selectedAreasOfFocus.includes(aof);
      return roleItem;
    });
  }

  checkIfAllSelected() {
    return this.selectedAreasOfFocus.length === this.fixedAreasOfFocus.map(item  => item.checked === true).length;
  }

  private checkItem(item: any, isSelected: boolean) {
    item.checked = isSelected;
    if (isSelected) {
      this.selectedAreasOfFocus.push(item.aof);
      this.allChecked = this.checkIfAllSelected();
    } else {
      let index = this.selectedAreasOfFocus.indexOf(item.aof);
      this.selectedAreasOfFocus.splice(index, 1);
      this.allChecked = false;
    }
  }

  public onChange(area: any, isSelected) {
    this.checkItem(area, isSelected.checked);
  }

  toggleSelectAllAoFOnPage() {
    if (!this.allChecked) {
      this.fixedAreasOfFocus = this.fixedAreasOfFocus.map(item => {
        item.checked = true;
        return item;
      });
      this.selectedAreasOfFocus = this.fixedAreasOfFocus.map(item =>  item.aof);
    } else {
      this.selectedAreasOfFocus = [];
      this.fixedAreasOfFocus.map(item => {
        item.checked = false;
        return item;
      });
    }
    this.allChecked = !this.allChecked;
  }

  doneModal() {
    setTimeout(() => {
      document.getElementById('aof-open-modal-btn').focus();
    }, 1000);
    this.accountCreationService.setChosenAreasFromModal(this.selectedAreasOfFocus);
    return this.modalRef.hide();
  }

  cancelModal() {
    setTimeout(() => {
      document.getElementById('aof-open-modal-btn').focus();
    }, 1000);
    return this.modalRef.hide();
  }
}
